/*
 * @Author: cn1994
 * @Date: 2023-09-13 16:10:10
 * @LastEditors: cn1994
 * @LastEditTime: 2024-03-03 15:05:03
 * @Description: file content
 */
const routes = [
  // 员工管理页面
  {
    path: "/staff",
    name: "staff",
    meta: {
      title: "员工管理",
      hasBack: false,
      volcengine: true,
    },
    component: () => import("@/pages/employeeManagement/index.vue"),
  },
  // 学管师查看用户页面
  {
    path: "/staff/lookUser",
    name: "staff/lookUser",
    meta: {
      title: "用户详情",
      hasBack: true
    },
    component: () => import("@/pages/employeeManagement/lookUser.vue")
  },
  // 员工详情
  {
    path: "/staff/info",
    name: "staff/info",
    meta: {
      title: "员工详情",
      hasBack: true
    },
    component: () => import("@/pages/employeeManagement/staffInfo.vue"),
  }
];

export default routes;
